import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import { SWITCH_PLATFORM, UPDATE_CREDIT_USERTYPE } from "./actionTypes";
import {
  switchPlatformError,
  switchPlatformSuccess,
  updateCreditUsertypeError,
  updateCreditUsertypeSuccess,
} from "./actions";

import {
  switchPlatformService,
  updateCreditUsertypeService,
} from "../../services/switchPlatformServices";

function* switchPlatform() {
  try {
    const response = yield call(switchPlatformService);
    yield put(switchPlatformSuccess(response.data));
  } catch (error) {
    yield put(switchPlatformError(error?.response?.data));
  }
};

function* updateCreditUsertype() {
  try {
    const response = yield call(updateCreditUsertypeService);
    yield put(updateCreditUsertypeSuccess(response.data));
  } catch (error) {
    yield put(updateCreditUsertypeError(error?.response?.data));
  }
};

export function* watchSwitchPlatform() {
  yield takeEvery(SWITCH_PLATFORM, switchPlatform);
};

export function* watchUpdateCreditUsertype() {
  yield takeEvery(UPDATE_CREDIT_USERTYPE, updateCreditUsertype);
};

function* SwitchPlatformSaga() {
  yield all([
    fork(watchSwitchPlatform),
    fork(watchUpdateCreditUsertype),
  ]);
}

export default SwitchPlatformSaga;